import React from "react";

import { animated } from "@react-spring/web";

import { getDataTestId } from "src/utils";
import { List } from "./components";
import { useViews } from "./hooks";

export const Views = () => {
  const { getViewsProps, values } = useViews();
  return (
    <animated.div {...getViewsProps()}>
      {values.views((style, view) => (
        <animated.div
          className={values.styles.view}
          {...getDataTestId(`coupons-${view.index === 0 ? "current" : "next"}`)}
          style={style}
        >
          <List gameId={view.id} />
        </animated.div>
      ))}
    </animated.div>
  );
};
